import React from 'react'
import Helmet from 'react-helmet'
import { observer } from 'mobx-react'
import { HeaderSink, HeaderTitle } from 'components/Header'
import Icon from 'components/Icon'
import './styles.sass'
import intercomUpdate from 'decorators/intercomUpdate'

@intercomUpdate({ screen: 'Refer a Friend' })
@observer
export default class ReferAFriend extends React.Component {
  render () {
    return (
      <div className="refer-a-friend">
        <Helmet title="Refer a Friend" />
        <HeaderSink small>
          <HeaderTitle>Refer a Friend</HeaderTitle>
        </HeaderSink>
        <div className="has-spacing-top">
          <div className="container">
            <div className="columns">
              <div className="column is-6-desktop is-offset-3-desktop has-text-centered">
                <Icon material name="attach money" size={80} color="#2395F3" />
                <h3 className="title is-3 is-semibold has-spacing-top">Give $20, Get $20</h3>
                <div className="content is-medium">
                  Refer friends to Taxfyle. They get $20 off their first tax return, you
                  get $20 off when they complete it.
                </div>
                <hr />
                <h4 className="title is-5 is-semibold">Your code:</h4>
                <input type="text" readOnly="readOnly" className="input has-text-centered is-medium code-field" value={this.props.rootStore.authStore.user.app_metadata.referral_code} />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/client/screens/ReferAFriend/index.jsx